"use client";

import { Button } from "@/components/ui/button";
import { ROOT_DOMAIN } from "@/lib/utils/navigation-utils";
import Link from "next/link";
import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";

const HOMEPAGE = `https://${ROOT_DOMAIN}`;

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <div
      className={`
        flex min-h-screen w-full flex-col items-center justify-center p-4 text-foreground
        md:pt-4
      `}
    >
      <div
        className={`
          flex w-full max-w-md flex-1 flex-col items-center gap-6
          md:flex-1 md:justify-center
        `}
      >
        <div className="flex flex-col items-center gap-2 text-center">
          <h1 className="text-2xl leading-8 font-bold tracking-tight text-foreground">
            Something went wrong!
          </h1>
          <p className="text-sm text-text-secondary">
            {error.message || "An unexpected error occurred."}
          </p>
        </div>

        <div className="flex w-full flex-col gap-3">
          <Button onClick={reset} className="w-full" variant="primary">
            Try Again
          </Button>
          <Button asChild className="w-full" variant="outline">
            <Link href={HOMEPAGE}>Return to home page</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
